import { useState, useEffect, useRef } from 'react';

// Add a global static flag to completely disable visibility change handling
// This is more aggressive than the context lock and will prevent ANY visibility-based refreshes
window.DISABLE_PAGE_VISIBILITY_REFRESH = true; // FORCE DISABLE visibility refresh globally

/**
 * A hook that tracks whether the page is currently visible or hidden
 * @returns {Object} visibility - Object containing visibility state
 * @returns {boolean} visibility.isVisible - True if page is visible, false if hidden
 * @returns {function} visibility.wasHidden - Function that returns true if page was previously hidden
 * @returns {function} visibility.disableRefresh - Function to disable visibility refresh
 * @returns {function} visibility.enableRefresh - Function to enable visibility refresh
 */
const usePageVisibility = () => {
  const logPrefix = '[usePageVisibility]';
  
  // ALWAYS return isVisible as true to prevent refreshes regardless of actual visibility
  const [isVisible, setIsVisible] = useState(true);
  const wasHiddenRef = useRef(false);
  
  // Never track hidden state
  const wasHidden = () => false;
  
  // These functions are no-ops now, but kept for API compatibility
  const disableRefresh = () => {
    window.DISABLE_PAGE_VISIBILITY_REFRESH = true;
  };
  
  const enableRefresh = () => {
    // Keep this disabled permanently for now
    console.log('Page visibility refresh remains disabled');
    // window.DISABLE_PAGE_VISIBILITY_REFRESH = false;
  };
  
  // No-op effect - intentionally not tracking visibility changes
  useEffect(() => {
    // Do nothing - this effect intentionally disabled
    
    return () => {
      // No cleanup needed
    };
  }, []);
  
  return {
    isVisible: true, // Always true to prevent refresh triggers
    wasHidden,
    disableRefresh,
    enableRefresh
  };
};

export default usePageVisibility; 